import { jsx as _jsx } from "react/jsx-runtime";
import { freddyTheme } from '@coolblue-development/freddy';
import { CheckmarkCircled } from '@coolblue-development/icons';
import { AvailabilityState as ClientAvailabilityState } from '@coolblue-development/next-availability-state/client';
import { useClientLogger } from '@coolblue-development/next-config/client';
import { useStoreAvailability } from '../../../context/StoreAvailabilityContext.js';
import { AvailabilityState } from '../../../enums/index.js';
import { useTranslation } from '../../../i18n/useTranslation.js';
import { getInStockAvailability } from '../../../utils/getInStockAvailability/getInStockAvailability.js';
import { getPreOrderAvailability } from '../../../utils/getPreOrderAvailability/getPreOrderAvailability.js';
import { getTemporaryOutOfStockAvailability } from '../../../utils/getTemporaryOutOfStockAvailability/getTemporaryOutOfStockAvailability.js';
export const StoreAvailabilityState = () => {
    const logger = useClientLogger();
    const { t } = useTranslation('storesStockOverlay.propositions');
    const { availabilityState, store, expectedReleaseDate, timeTravelOverride } = useStoreAvailability();
    const getAvailabilityState = () => {
        switch (availabilityState) {
            case AvailabilityState.OnStock: {
                const { promise, description } = getInStockAvailability({
                    schedules: store.schedules,
                    storeDates: store.storeDates,
                    timeTravelOverride,
                    t,
                });
                return {
                    promise,
                    description,
                    state: {
                        color: freddyTheme.color.font.sentimentPositiveContrast,
                        icon: _jsx(CheckmarkCircled, { color: freddyTheme.color.icon.sentimentPositiveContrast }),
                    },
                };
            }
            case AvailabilityState.PreOrder: {
                if (!expectedReleaseDate)
                    return {
                        promise: '',
                        description: '',
                        state: {
                            color: freddyTheme.color.font.sentimentNegative,
                        },
                    };
                const { promise, description } = getPreOrderAvailability({
                    expectedReleaseDate,
                    schedules: store.schedules,
                    timeTravelOverride,
                    t,
                });
                return {
                    promise,
                    description,
                    state: {
                        color: freddyTheme.color.font.sentimentNegative,
                    },
                };
            }
            case AvailabilityState.TemporaryOutOfStock: {
                const { promise, description } = getTemporaryOutOfStockAvailability({
                    schedules: store.schedules,
                    timeTravelOverride,
                    t,
                    logger,
                });
                return {
                    promise,
                    description,
                    state: {
                        color: freddyTheme.color.font.sentimentNegative,
                    },
                };
            }
            default: {
                return {
                    promise: t('temporaryOutOfStock'),
                    description: t('notAvailableForPickup'),
                    state: {
                        color: freddyTheme.color.font.sentimentNegative,
                    },
                };
            }
        }
    };
    return _jsx(ClientAvailabilityState, { ...getAvailabilityState() });
};
//# sourceMappingURL=StoreAvailabilityState.js.map